import React from 'react'
import { ContentColumn } from '../..'
import BenchmarkingPlaceholder from '../../components/BenchmarkingPlaceholder'

// "Tidpunkter & insatser" — korsningar mellan beräkningsstödets dimensioner
// (insats × tidpunkt, insats × nivå, beställd tid × antal besök). Kommunjämförelse
// görs via två grupperade stapeldiagram sida vid sida.
export const benchmarkingCalculationCrossings: ContentColumn[] = [
  {
    pageTitle: 'Tidpunkter & insatser',
    content: (
      <BenchmarkingPlaceholder
        text={
          <>
            <b>Beskrivning</b>
            <br />
            Vyer som korsar två av beräkningsstödets dimensioner — t.ex. insatser per tidpunkt,
            tidpunkter per insats, insats × nivå samt beställd tid × antal besök.
            <br />
            <br />
            <b>Status</b>
            <br />
            Strukturen är på plats. Graferna byggs ut inkrementellt. Kommunjämförelse sker via
            två grupperade stapeldiagram sida vid sida (vald kommun vs jämförelsekommun).
          </>
        }
      />
    ),
  },
]
